import React from 'react';
import { useTranslation } from 'react-i18next';

const UnexpectedErrorPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='grid-flex grid-justify-center'>
      <h1>{t('unexpectedErrorPage.heading')}</h1>
    </div>
  );
};

export default UnexpectedErrorPage;
